/**
 * @desc 删除料耗比
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.delete({
    url: '/web/consumptionRatio/delete',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.delete({
    url: '/mock/web/consumptionRatio/delete',

    params,
  });
}
